import clsx from 'clsx';
import BasicImage from 'core/BasicImage';
import { Typography } from 'core/Typography';
import React from 'react';

type SlidePropsType = {
    title: string;
    author: string;
    position: string;
    icon: string;
    widthIcon?: number;
    heightIcon?: number;
    filled?: boolean;
    quoteClassName?: string;
};

const Slide = ({
    title,
    author,
    icon,
    position,
    widthIcon,
    heightIcon,
    filled,
    quoteClassName,
}: SlidePropsType) => {
    return (
        <div
            className={clsx(
                filled ? 'bg-bg-grey p-6 lg:p-8 rounded-2xl lg:rounded-3xl' : '',
                'relative flex mt-3 lg:mt-6 flex-col gap-5'
            )}
        >
            <div className="relative">
                <Typography size={filled ? 'default' : 'big'} variant={'p'}>
                    <span className={clsx(filled ? '' : '-left-5', 'absolute', quoteClassName)}>
                        «
                    </span>
                    <span className={clsx(filled ? 'pl-3' : 'pl-5')}>{title}</span>
                    <span className={clsx('font-bold', quoteClassName)}>»</span>
                </Typography>
            </div>

            <div className="flex items-center justify-between gap-5 max-mobile:flex-col">
                <div className="flex flex-col">
                    <Typography variant={'p'} className={'lg:text-xl! font-semibold!'}>
                        {author}
                    </Typography>

                    <Typography variant={'p'} className={'lg:text-lg! text-text-subscription'}>
                        {position}
                    </Typography>
                </div>

                <BasicImage
                    width={widthIcon ? widthIcon : 148}
                    height={heightIcon ? heightIcon : 57}
                    src={icon}
                    alt="icon"
                    className="max-mobile:max-w-[148px]"
                />
            </div>
        </div>
    );
};

export default Slide;
